// extracted by mini-css-extract-plugin
export default {"node":"NodeTypes_node__bKkqo","content":"NodeTypes_content__XIYg3","handle":"NodeTypes_handle__ozota","placeholder":"NodeTypes_placeholder__Kf7XY"};